import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import moment from 'moment';
import {
	changeCurrentPath,
	fetchDeleteList,
	resetDeleteListState,
	resetMainListState,
	resetConsigneeListStateNew,
	updateDeleteFlag
} from '../../actions';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import SpNav from '../../common/containers/sp_nav'
import Footer from '../../common/containers/footer';

import ErrorDialog from '../../common/components/dialog/error-dialog';
import ReloadModal from '../../common/components/dialog/reload-dialog';
import LogoutModal from '../../common/components/dialog/logout-dialog';
import MainButtons from '../../common/components/main-buttons';
import Tables from '../../common/components/table/common-table';
import AlertDialog from '../../common/components/dialog/alert-dialog';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';

import FormGroup from '@material-ui/core/FormGroup';
import Button from '@material-ui/core/Button';


import {DatePicker}from 'material-ui-pickers';



const columns = [
	{ name: 'TorikomiDateTime', title: '取込日時',width:150 },
	{ name: 'KanriNO', title: '管理番号' ,width:250},
	{ name: 'ManagementDivideName', title: '連携方法' ,width:150},
	{ name: 'DenpyoMaisu', title: '伝票枚数' ,width:130, align:'right'},
	{ name: 'DataTeikyoumotoName', title: 'データ提供元' ,width:130}
];

const numberColumns = ['DenpyoMaisu'];


const styles = theme => ({
	datePicker : {
		width:'150px'
	},
	datePickerLast:{
		marginRight:30
	},
	fromTo : {
		padding: '0 15px',
		fontSize: '1.5rem',
		fontFamily: "Roboto, Helvetica, Arial, sans-serif",
		marginTop:7
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		fontFamily:'Noto Sans JP'
	},
	expands : {
		boxShadow:'initial'
	},
	textField :{
		width:'100%',
		maxWidth:500
	},
	row:{
		width:'100%'
	}
});


class DeleteList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rows : [],
			KanriNO:this.props.settings.KanriNO,
			selectedDateFrom:this.props.settings.selectedDateFrom,
			selectedDateTo:this.props.settings.selectedDateTo,
			selections:this.props.settings.selections,
			dialogOpen:false
        };

    }
    /** override methods **/
	UNSAFE_componentWillMount(){
		this.handleClickSumup();

		const {dispatch} = this.props;
		dispatch(resetMainListState());
		dispatch(resetConsigneeListStateNew());
	}
	componentDidMount() {
		const { dispatch, history } = this.props;
		window.scrollTo(0, 0);
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}
	componentWillUnmount(){
		const {dispatch} = this.props;
		dispatch(resetDeleteListState());
	}


    /** event handlers **/
	handleKanriNOChange = event => {
		this.setState({ KanriNO: event.target.value });
	};
	handleDateFromChange = date => {
		let selectedDateTo = this.state.selectedDateTo;
		if(selectedDateTo){
			const dateDiff = selectedDateTo.diff(date,'days');
			if(dateDiff < 0) {
				selectedDateTo = new moment(date);
			}
			else if(dateDiff > 14){
				selectedDateTo = new moment(date);
				selectedDateTo.add(14,'days');
			}
		}
		this.setState({
			selectedDateFrom: date,
			selectedDateTo
		});
	};
	handleDateFromInputChange = (e) =>{
		if(!e.target.value) this.setState({ selectedDateFrom: null });
	};
	handleDateToChange = date => {
		let selectedDateFrom = this.state.selectedDateFrom;
		if(selectedDateFrom){
			const dateDiff = date.diff(selectedDateFrom,'days');
			if(dateDiff < 0) {
				selectedDateFrom = new moment(date);
			}
			else if(dateDiff > 14){
				selectedDateFrom = new moment(date);
				selectedDateFrom.add(-14,'days');
			}
		}
		this.setState({
			selectedDateFrom,
			selectedDateTo: date
		});
	};
	handleDateToInputChange = (e) =>{
		if(!e.target.value) this.setState({ selectedDateTo: null });
	};
	handleSelectionChange = selections => {
		this.setState({
			selections
		});
	};

	handleClickSumup = event => {
		const {dispatch} = this.props;
		const {KanriNO, selectedDateFrom, selectedDateTo} = this.state;
		this.setState({
			selections:[]
		});
		dispatch(fetchDeleteList({
			KanriNO : !(KanriNO) ? null : KanriNO,
			selectedDateFrom : !(selectedDateFrom) ? null : moment(selectedDateFrom).format('YYYY-MM-DD'),
			selectedDateTo : !(selectedDateTo) ? null : moment(selectedDateTo).format('YYYY-MM-DD'),
			SessionID : this.props.auth.SessionID
		}));
	};
	handleClickDelete = event => {
		this.setState({
			dialogOpen : true
		});
	};
	doDelete = () =>{
		this.setState({
			dialogOpen:false
		});

		const { dispatch,auth} = this.props;
		const selections = this.state.selections.map(selection=>{
			return selection["id"];
		});
		const {KanriNO, selectedDateFrom, selectedDateTo} = this.state;
		dispatch(updateDeleteFlag({
			KanriNO : !(KanriNO) ? null : KanriNO,
			selectedDateFrom : !(selectedDateFrom) ? null : moment(selectedDateFrom).format('YYYY-MM-DD'),
			selectedDateTo : !(selectedDateTo) ? null : moment(selectedDateTo).format('YYYY-MM-DD'),
			SessionID : auth.SessionID,
			selections
		}));

	};

	cancelDelete = () =>{
		this.setState({
			dialogOpen:false
		});
	};


	render() {
		const { classes, settings } = this.props;
		const {
			selectedDateFrom,selectedDateTo,selections,dialogOpen
		} = this.state;

		const rows = settings.data;
		const disabled = !(selections.length);

		const mainButtons = [
			{type:'DELETE',func:this.handleClickDelete,disabled:disabled},

		];

		return (
			<div id="main_container">
				{settings.isFetching &&
				<Progress/>
				}
				<SpNav history={this.props.history}/>
				<Header history={this.props.history}/>
				<article>
					<section className="title_area">
						<h2>伝票削除</h2>
					</section>
					<ExpansionPanel defaultExpanded className={classNames("with_button condition_area",classes.expands)}>
						<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
							<Typography className={classes.heading}>抽出条件</Typography>
						</ExpansionPanelSummary>
						<ExpansionPanelDetails>
							<FormGroup row className={classes.row}>

								<DatePicker
									keyboard
									label="取込日開始"
									minDateMessage={"7年前までの日付を入力"}
									maxDateMessage={"10日後までの日付を入力"}
									minDate={new moment().add(-7, 'years')}
									maxDate={new moment().add(10, 'days')}
									value={selectedDateFrom}
									onChange={this.handleDateFromChange}
									onInputChange={this.handleDateFromInputChange}
									format="YYYY/MM/DD"
									className={classes.datePicker}
									invalidDateMessage="日付が正しくありません"
									cancelLabel={"キャンセル"}
								/>
								<div className={classes.fromTo}>-</div>
								<DatePicker
									keyboard
									label="取込日終了"
									minDateMessage={"7年前までの日付を入力"}
									maxDateMessage={"10日後までの日付を入力"}
									minDate={new moment().add(-7, 'years')}
									maxDate={new moment().add(10, 'days')}
									value={selectedDateTo}
									onChange={this.handleDateToChange}
									onInputChange={this.handleDateToInputChange}
									className={classNames(classes.datePicker,classes.datePickerLast)}
									format="YYYY/MM/DD"
									invalidDateMessage="日付が正しくありません"
									cancelLabel={"キャンセル"}
								/>
								<TextField
									label="管理番号"
									placeholder="管理番号"
									className={classes.textField}
									onChange={this.handleKanriNOChange}
									inputProps={{
										maxLength:50
									}}
								/>
							</FormGroup>
						</ExpansionPanelDetails>
						<Divider />
						<ExpansionPanelActions>
							<Button variant="contained" color="primary" size="large" onClick={this.handleClickSumup}>
								集計
							</Button>
						</ExpansionPanelActions>
					</ExpansionPanel>
					<section className="with_button">
						<Tables
							dataSource={rows}
							columns={columns}
							selections={selections}
							numberColumns={numberColumns}
							getSelections={this.handleSelectionChange}
							defaultSorts={[{columnName:'TorikomiDateTime',direction:'asc'}]}
							isDefaultUnChecked={true}
						/>
					</section>
				</article>
				<MainButtons buttons={mainButtons}/>
				<Footer/>
				<AlertDialog
					open={dialogOpen}
					title={"確認"}
					text={<span>選択された伝票が削除されます</span>}
					okFunction={this.doDelete}
					closeFunction={this.cancelDelete}
				/>
				<ErrorDialog
					open={this.props.settings.isProcessError}
				/>
				<ReloadModal />
				<LogoutModal />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation : state.navigation,
		auth: state.auth,
		settings : state.deleteListSettings
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(DeleteList);



// WEBPACK FOOTER //
// ./src/routes/delete-list/index.js